import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api, currentRole } from "@/lib/api";

const TONE = {
  "30": "border-amber-500/40 bg-amber-500/10 text-amber-200",
  "15": "border-orange-500/50 bg-orange-500/10 text-orange-200",
  "7": "border-red-500/50 bg-red-500/10 text-red-200",
  expired: "border-red-600 bg-red-600/20 text-red-100",
};

export default function DscExpiryBanner({ showLink = true }) {
  const [s, setS] = useState(null);
  useEffect(() => {
    if (currentRole() === "super_admin") api.get("/admin/dsc/expiry-status").then((r) => setS(r.data)).catch(() => {});
  }, []);
  if (!s || !TONE[s.level]) return null;
  const expired = s.level === "expired";
  return (
    <div className={`rounded-xl border p-4 mb-5 flex flex-wrap items-center justify-between gap-3 ${TONE[s.level]}`} data-testid="dsc-expiry-banner" data-level={s.level}>
      <div className="flex items-start gap-3">
        <AlertTriangle size={18} className="shrink-0 mt-0.5"/>
        <div>
          <div className="font-bold" data-testid="dsc-expiry-title">
            {expired ? "Director's DSC has expired — agreements cannot be signed" : `Director's DSC expires in ${s.days_left} day${s.days_left === 1 ? "" : "s"}`}
          </div>
          <div className="text-xs opacity-80 mt-0.5">{s.subject_cn} · valid until {new Date(s.valid_to).toLocaleDateString("en-IN", { dateStyle: "medium" })}. Renew it with your DSC provider, then register the new certificate.</div>
        </div>
      </div>
      {showLink && <Link to="/admin/agreement-signing" className="text-xs font-semibold underline underline-offset-4" data-testid="dsc-expiry-link">Open Agreement Signing</Link>}
    </div>
  );
}
